import React from 'react';
import {ItemPresenter} from "../ItemPresenter";

function AnimalHen() {
  return (
    <ItemPresenter imagePath={"/images/animals/hen.png"} bottomLabel={"Galinha"}
      customImageWidth={" "}
      />
  );
}

export default AnimalHen;